export default "__VITE_ASSET__KkIamVSx__"